import { Copy, H1, H2, H3, H4, H5, H6, Link } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';

export const stripMarkdownHeading = (str = '') => {
  if (typeof str !== 'string') return str;

  const ALL_HASHES_BUT_QUOTED_PATTERN = /#(?=(?:[^"']*["'][^"']*["'])*[^"']*$)/g;
  return str.replace(ALL_HASHES_BUT_QUOTED_PATTERN, '');
};

export const getTitleComponent = (str = '', defaultHeader) => {
  if (str.match(/^#######/)) {
    // eslint-disable-next-line no-console
    console.warn(`No heading component available for "${str}"`);
    return defaultHeader || Copy;
  }

  if (str.match(/^######/)) return H6;
  if (str.match(/^#####/)) return H5;
  if (str.match(/^####/)) return H4;
  if (str.match(/^###/)) return H3;
  if (str.match(/^##/)) return H2;
  if ((str.indexOf('#') < 0 && !defaultHeader) || str.match(/^#/)) return H1;

  return defaultHeader || Copy;
};

export const styledCompiler = (children, overrides = {}) =>
  compiler(children, {
    overrides: {
      a: {
        component: Link,
        props: {
          color: 'primary',
          disableHover: true,
          fontSize: 'inherit',
        },
      },
      p: {
        component: Copy,
        props: {
          fontSize: 'inherit',
        },
      },
      ...overrides,
    },
  });

/**
 * Removes HTML tags from a string using a regular expression.
 *
 * @param {string} text The string from which HTML tags need to be removed.
 * @returns {string|*} The string without HTML tags if the input was a string.
 * Returns the original argument unchanged if it is not a string.
 */
export const removeMarkdown = text => {
  const regex = /(<([^>]+)>)/gi;
  if (typeof text !== 'string') return text;
  return text.replace(regex, '');
};

/**
 * * Removes all HTML tags and their content from a string.
 *  * This function is designed to clean a string from HTML tags and the text between them.
 *  *
 *  * @param {string|undefined} - The string from which HTML tags and their content need to be removed.
 *  * @returns {string|undefined} The string without HTML tags and the text between them.
 */
export const removeAllTagsFromMarkdown = str => str?.trim()?.replace(/<[^>]+>[^<]*<\/[^>]+>/gi, '');

/**
 * Removes all HTML tags from a string, including self-closing tags.
 *  * This function ensures line breaks are replaced with a space, removes all tags
 *  * and their content, including self-closing ones, and collapses multiple spaces.
 *
 *  * @param {string} str - The string from which to remove HTML tags and self-closing tags.
 *  * @returns {string} The cleaned string with all tags and extra whitespace removed.
 */
export const removeAllTagsFromMarkdownIncludingSelfClosing = str => {
  if (!str || typeof str !== 'string') return '';

  return str
    .trim()
    .replace(/\s*<br\s*\/?>\s*/gi, ' ') // ensure consistent spacing for line breaks
    .replace(/<[^>]+>.*?<\/[^>]+>|<[^>]+\/?>/gis, '')
    .replace(/\s{2,}/g, ' '); // collapse multiple spaces
};
